import { AppLayout } from 'layouts';
import type { OrganizationDetail } from 'models';
import type { ReactNode } from 'react';
import { useOrganizationDetailQuery } from '../queries';
import { OrganizationLayoutSkeleton } from './organization-layout-skeleton';

type P = {
  children: (organization: OrganizationDetail) => ReactNode;
  header?: (organization: OrganizationDetail) => ReactNode;
  organizationId: string;
};

const OrganizationLayout = ({ children, header, organizationId }: P) => {
  const { data: organization, error } = useOrganizationDetailQuery({ organizationId });

  return (
    <AppLayout error={error}>
      {organization ? (
        <>
          {header?.(organization)}
          {children(organization)}
        </>
      ) : (
        <OrganizationLayoutSkeleton view={header ? 'detail' : 'list'} />
      )}
    </AppLayout>
  );
};

export default OrganizationLayout;
